import { Scheduler } from '@aldabil/react-scheduler'
import { useState } from 'react'
import { useEffect, useRef, useCallback  } from 'react'
import { useParams, Link } from 'react-router-dom'
import {fetchWithAuth, getCSRFToken, canEditAll, isAssociateManagerOrAbove, getUsername} from '../auth'
import { Form, FormField, FormGroup, TextArea, Button, Icon,Checkbox, Message } from 'semantic-ui-react'
import {getTeamEventSchedule, getTeamSchedule} from '../common/apiClient'
import { statusMap } from '../common/helpers'
import { LoadingWrapper } from '../common/LoadingWrapper'
import '../members/Members.css'
import moment from 'moment';

function toISOStringWithTimezone(date) {
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1)
    return localISOTime
}

export const eventTypes = [
    {
        key: 'teamEvent',
        value: 'teamEvent',
        text: 'Team Event'
    }
]

const CustomEditor = ({ scheduler, getEvents, setError }) => {
    const event = scheduler.edited
    const creating = !event
    const user = sessionStorage.getItem("user")
    const userObj = JSON.parse(user)
    const [fieldErrors, setFieldErrors] = useState({})
    const [eventDetails, setEventDetails] = useState( {
        start: toISOStringWithTimezone(scheduler.state.start.value),
        end: toISOStringWithTimezone(scheduler.state.end.value),
        title: event?.title,
        notes: event?.notes,
        type: "Team Event",
        approvalStatus: 'approved',
        approvedBy: event?event.approvedBy : {"name": userObj?.username, "id": userObj?.username},
    })
    const { id } = useParams()
    function handleChange(key, value) {
        const eventDetailsClone = structuredClone(eventDetails)
        fieldErrors[key] = false
        if (key === 'allDay') {
            if (value) {
                // TODO update based on working hours
                const start = new Date()
                start.setHours(6, 0, 0, 0)
                const end = new Date()
                end.setHours(18, 0, 0, 0)
                eventDetailsClone.start = toISOStringWithTimezone(start)
                eventDetailsClone.end = toISOStringWithTimezone(end)
            }
        }
        eventDetailsClone[key] = value
        setEventDetails(eventDetailsClone)
    }

    async function postEvent(eventDetails) {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teamevents/' + id + '/schedule/', {
            headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify(eventDetails)
        })
        if(!resp.ok) {
            setError("An error occurred. Please reach out to your supervisor.")
        }
    }

     async function patchEvent(eventDetails) {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teamevents/' + id + '/schedule/' + event.event_id + '/', {
            headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
            credentials: 'include',
            method: 'PATCH',
            body: JSON.stringify(eventDetails)
        })
        if(!resp.ok) {
            setError("An error occurred. Please reach out to your supervisor.")
        }
    }


    function handleSubmit(){
    const errors = {}
    for (const field of ['start', 'end', 'title', 'type']) {
        if (!eventDetails[field]) {
            errors[field] = "This field is required."
        }
    }
    if (Object.keys(errors).length !== 0) {
        //setFieldErrors(errors)
        return
    }

    const start = new Date(eventDetails.start).toISOString()
    const end = new Date(eventDetails.end).toISOString()
    const eventDetailsClone = {
        start: start,
        end: end,
        title: eventDetails.title,
        notes: eventDetails.notes,
        type: eventDetails.type,
        approvalStatus: eventDetails.approvalStatus,
        approvedBy: eventDetails.approvedBy?.userId
    }
    if (creating) {
        postEvent(eventDetailsClone).then(() => {
            scheduler.close()
            getEvents()
            eventDetailsClone.start = new Date(eventDetailsClone.start)
            eventDetailsClone.end = new Date(eventDetailsClone.end)
            scheduler.onConfirm(eventDetailsClone, "create")
        })
    } else {
            patchEvent(eventDetailsClone).then(() => {
                scheduler.close()
                getEvents()
                eventDetailsClone.start = new Date(eventDetailsClone.start)
                eventDetailsClone.end = new Date(eventDetailsClone.end)
                scheduler.onConfirm(eventDetailsClone, "edit")
            })
        }
    }

    const midnightTonight = new Date()
    midnightTonight.setHours(23, 59, 59, 999)

    const className = isAssociateManagerOrAbove() ? "" : "icct-disabled-input icct-disabled-selection"

    return <div id="create-event-modal">
        <Form>
            <FormField required>
                <label>Title</label>
                <Form.Input
                    className={className}
                    value={eventDetails.title}
                    onChange={(eve, data) => handleChange('title', data.value)} error={fieldErrors.title} />
            </FormField>
            <FormField>
                <label>Notes</label>
                <TextArea
                    className={className}
                    value={eventDetails.notes}
                    onChange={(eve, data) => handleChange('notes', data.value)} />
            </FormField>
            <FormGroup>
                <FormField required width={8}>
                    <label>Type</label>
                     <Form.Input
                        className={"icct-disabled-input"}
                        value={eventDetails.type} />
                </FormField>
                <FormField width={8}>
                    <label style={{ opacity: "1" }}>Approval Status</label>
                    <Form.Input
                        className={"icct-disabled-input"}
                        style={{ opacity: "1" }}
                        value={statusMap[eventDetails.approvalStatus]} />
                </FormField>
            </FormGroup>
            <FormField>
                <label>Approved By</label>
                <Form.Input
                    className={"icct-disabled-input"}
                    value={eventDetails.approvedBy?.name} />
            </FormField>
            <FormGroup>
                <FormField>
                    <label>Start</label>
                    <Form.Input
                        disabled={eventDetails.allDay}
                        className={className}
                        aria-label="Date and time" type="datetime-local"
                        value={eventDetails.start}
                        onChange={(eve, data) => handleChange('start', data.value)} />
                </FormField>
                <FormField style={{ maxWidth: "20rem" }}>
                    <label>End</label>
                    <Form.Input
                        disabled={eventDetails.allDay}
                        className={className}
                        aria-label="Date and time"
                        error={(eventDetails.start > eventDetails.end) ? "End time must be greater than start time." : null}
                        type="datetime-local"
                        value={eventDetails.end}
                        onChange={(eve, data) => handleChange('end', data.value)}
                    />
                </FormField>
            </FormGroup>
        </Form>
         {(isAssociateManagerOrAbove()) && <div style={{ display: "flex", justifyContent: "space-between" }}>
            {(new Date(eventDetails.start) > midnightTonight || new Date(eventDetails.end) > midnightTonight) ? <FormField>
                <Button style={{ backgroundColor: "var(--add)", color: "white" }} onClick={handleSubmit}>Submit</Button>
            </FormField> : <FormField style={{ margin: "0.5rem" }}><Icon className="exclamation circle" />Start or end must be greater than today</FormField>}
            <FormField>
                <Button style={{ backgroundColor: "var(--delete)", color: "white" }} onClick={scheduler.close}>Cancel</Button>
            </FormField>
        </div>}
    </div>
}

export const TeamScheduler = () => {
    const { id } = useParams()
    const [events, setEvents] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const calendarRef = useRef(null)
    const isLandscape = window.matchMedia('(orientation:landscape)').matches

    async function getEvents() {
        const statusToColor = {
            'pending': '#AAAAAA', // gray
            'approved': 'var(--tds-blue)',
            'denied': '#FF5555' // red
        }
        setLoading(true)
        const resp = await getTeamSchedule(id)
        const teamEventsResp = await getTeamEventSchedule(id)
        if (resp.status === 404) {
            setError("This team does not exist.")
        } else if (!resp.ok || !teamEventsResp.ok) {
            setError("Something went wrong.")
        } else {
            const respJson = await resp.json()
            let teamEventsJson = await teamEventsResp.json()
            setEvents(respJson.concat(teamEventsJson).filter((event) => event.approvalStatus !== 'denied').map((event) => {

                let isDeletable = false
                let isEditable = false
                const midnightTonight = new Date()
                midnightTonight.setHours(23, 59, 59, 999)
                const today = new Date()
                today.setHours(0, 0, 0, 0)
                if (event.team && isAssociateManagerOrAbove() && new Date(event.start) > midnightTonight){
                    isDeletable = true
                    isEditable = true
                }
                 if (event.team && isAssociateManagerOrAbove() && new Date(event.start) >= today){
                    isDeletable = true
                }
                return {
                    event_id: event.id,
                    start: new Date(event.start),
                    end: new Date(event.end),
                    title: event.title,
                    notes: event.notes,
                    type: event.type,
                    color: statusToColor[event.approvalStatus],
                    eventColor: statusToColor[event.approvalStatus],
                    approvalStatus: event.approvalStatus,
                    approvedBy: event.approvedBy,
                    member: event.member,
                    teamEvent: event.team? event.title: "",
                    deletable: isDeletable,
                    editable: isEditable
                }
            }))
        }
        setLoading(false)
    }

    async function deleteEvent(eventId) {
        await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teamevents/' + id + '/schedule/'+ eventId + '/', {
            headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
            credentials: 'include',
            method: 'DELETE'
        })
        getEvents()
    }
    function handleDelete(id) {
        deleteEvent(id)
    }


    useEffect(() => {
        getEvents()
    }, [])

    const canEdit = isAssociateManagerOrAbove()

    return (
        <LoadingWrapper loading={loading} text="Loading calendar">
            <div style={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
                {error && <Message style={{ width: "fit-content" }} negative>{error}</Message>}
            </div>
            <Scheduler
                editable={canEdit}
                ref={calendarRef}
                viewerExtraComponent={(fields, event) => {
                    return <Link to={'/members/' + event.member?.userId + '/view'}>
                        {event.member?.name}
                    </Link>
                }}
                customEditor={(scheduler) => <CustomEditor scheduler={scheduler} getEvents={getEvents} setError={setError}/>}
                events={events}
                deletable={false}
                onDelete={handleDelete}
                week={{ startHour: 6, endHour: 20, weekStartOn: 0 }}
                draggable={false}
                eventRenderer={({ event, ...props }) => {
                    return <div className="event-on-calendar" style={{ backgroundColor: event.eventColor }} {...props}>
                        { event.member && <div className="overflow-text">{event.member?.name} - {statusMap[event.type] ? statusMap[event.type] : event.type}</div> }
                        { event.teamEvent && <div className="overflow-text">{event.teamEvent}</div> }
                        <div className="overflow-text">{event.start.toLocaleTimeString("en-US", { timeStyle: "short" })} to {event.end.toLocaleTimeString("en-US", { timeStyle: "short" })}</div>
                    </div>
                }} />
        </LoadingWrapper>
    )
}